// Dépendances Angular
import { inject, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  //HttpClient,
  HttpClientModule,
} from '@angular/common/http';

// Dépendances Externes
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';

// Fichiers du projet
import {
  AuthenticationComponent,
  AssistanceComponent,
  CallbackComponent,
} from '@features/index';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { configSSO } from '@environments/sso/auth-sso';
import { SharedModule } from '@shared/shared.module';
import { HttpTokenInterceptor } from '@core/interceptor/http.interceptor';
import { PageNotAuthorizedComponent } from '@features/errors/components/page-not-authorized/page-not-authorized.component';
import { PageNotFoundComponent } from '@features/errors/components/page-not-found/page-not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthenticationComponent,
    AssistanceComponent,
    CallbackComponent,
    PageNotAuthorizedComponent,
    PageNotFoundComponent,
  ],
  imports: [
    // Dépendances Angular
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    // Dépendances externes
    SharedModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  private readonly oAuthService: OAuthService = inject(OAuthService);

  constructor() {
    this.oAuthService.configure(configSSO);
    this.oAuthService.setupAutomaticSilentRefresh({}, 'access_token');
    this.oAuthService.loadDiscoveryDocumentAndTryLogin();
  }
}
